import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { CSSProperties, ReactNode } from 'react';

import Divider from '../../../../divider/divider';

interface Props {
  action: { icon: { component: any; color: CSSProperties['color'] }; text: string; content: ReactNode };
  filtersContent: ReactNode;
  metaContent: ReactNode;
}

const DetailsFactory = ({ action, filtersContent, metaContent }: Props) => {
  const theme = useTheme();

  return (
    <Box display="flex" justifyContent="space-between">
      <Box display="flex" flexDirection="column" flex={1} maxWidth="60%">
        <Box display="flex" flexDirection="column" alignItems="center" data-testid="report-status-details">
          <action.icon.component style={{ fontSize: theme.elements.icon.size.xl, color: action.icon.color }} />
          <Typography align="center">{action.text}</Typography>
        </Box>
        <Box data-testid="report-actions-details">{action.content}</Box>
      </Box>
      <Divider orientation="vertical" flexItem />
      <Box display="flex" flexDirection="column" alignItems="flex-start" minWidth="40%" maxWidth="40%">
        <Box data-testid="report-meta-details">{metaContent}</Box>
        <Box data-testid="report-filters-details">{filtersContent}</Box>
      </Box>
    </Box>
  );
};

export default DetailsFactory;
